import script from "./new-edit-email-templates-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./new-edit-email-templates-modal.vue?vue&type=script&setup=true&lang=ts"

import "./new-edit-email-templates-modal.vue?vue&type=style&index=0&id=147ed28f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-147ed28f"]])

export default __exports__